<template>
    <iframe src="https://blog.harnessapp.com/donate-button" class="container-height" width="100%" style="border: 0;padding: 0;margin: 0">
    </iframe>
</template>

<script>
  export default {
    name: 'DonateButton',
    metaInfo: {
      title: 'Donation Button',
    },
  };
</script>

